<template>
  <div>
    <b-card  title="Pergunte ao analista">
      <b-button
      class="btn-sm btn-nav-link btn-nav-link-white"
      size="sm"
      variant="flat-primary"
      @click="reportData"
    >
      <feather-icon icon="FileTextIcon" />
      Exportar
    </b-button> 
      <custom-g-table
        v-if="displayTable"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="items"
        :limit="limit"
        :totalRows="totalRows"
        :hasAnswer="true"
        @changePage="onChangePage"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
        @openAnswer="onAnswer"
      />
    </b-card>

    <b-modal
      ref="answer-question-modal"
      modal-class="modal-primary"
      title="Resposta"
      ok-title="Responder"
      centered
      size="lg"
    >
      <div class="d-block" v-if="selectedData">
        <div class="mt-1 mb-1"><b>Cliente:</b> {{selectedData.client.email}}</div>
        <div class="mt-1 mb-1"><b>Pergunta:</b> {{selectedData.question}}</div>
        <div class="mt-1 mb-1" v-if="selectedData.answer && selectedData.answer.length > 0"><b>Respostas:</b> {{selectedData.answer.map(item => item.text).join(' || ')}}</div>
        <!-- <b-form-input v-model="currAnswer" class="form-control-merge mt-1 mb-1" placeholder="Resposta" style="width: 750px;"/> -->
        <b-form-textarea
          class="mt-1 mb-1"
          id="text"
          placeholder="Resposta"
          rows="5"
          v-model="currAnswer"
        />
        <b-button
          variant="primary"
          class="mr-1"
          @click.stop="sendAnswer"
        >
          Responder
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BButton, BModal, BFormTextarea } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import askAnalystService from "@/providers/askAnalystService";
// import CustomFilter from "@/views/custom/table/CustomFilter.vue";
import AppConstants from "@/appConstants";
import dropdownService from "@/providers/dropdownService";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import messageDialogHelper from '@/helpers/message-dialog-helper';
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    BButton,
    CustomGTable,
    BModal,
    BFormTextarea
    // CustomFilter,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      limit: AppConstants.PAGINATOR_DEFAULT_LIMIT,
      totalRows: 0,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        { field: "action_buttons", label: "Ações", sortable: false },
        { field: "client", label: "Cliente", type: "object", object_field: "email", sortable: false },
        { field: "question", label: "Pergunta", sortable: true, limitText: 200, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por email', trigger: 'enter' } },
        { field: "answer", label: "Resposta", sortable: false, type: "array", limitText: 200 },
        { field: "user_answer", label: "Resposta do Usuário", sortable: false, type: "object", object_field: "email" },
        { field: "subject", label: "Assunto", sortable: false, type: "object", filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por assunto', filterDropdownItems: [] } },
        { field: "sendmail_users", label: "Emails recebidos", sortable: false, type: "array", object_field: "email" },
        { field: "origin", label: "Origem", type: "object", sortable: false, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por origem', filterDropdownItems: [] } },
        { field: "dt_create", label: "Criação", type: "custom_date", sortable: true, filterOptions: { filterValue: '', enabled: true, placeholder: 'Pesquisar por data', trigger: 'enter' } },
      ],
      /* eslint-disable global-require */
      items: [],
      selectedData: null,
      currAnswer: ''
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", 'Pergunte ao analista');
    this.loadDataFilter();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }
      return params;
    },
  },
  methods: {
    sendAnswer() {
      console.log('[sendAnswer]');
      if (this.currAnswer) {
        const body = {
          id: this.selectedData._id,
          answer: this.currAnswer
        }
        askAnalystService.answerQuestion(new URLSearchParams(), body).then(() => {
          this.closeModalAnswer();
          this.currAnswer = '';
          this.selectedData = null;
          this.loadData();
          messageDialogHelper.displaySuccessMessage('enviado',()=> {});
        })
        .catch((err) => console.log(err));
      }
    },
    onAnswer(data) {
      this.currAnswer = '';
      this.selectedData = null;
      this.$refs["answer-question-modal"].show();
      this.selectedData = data;
    },
    closeModalAnswer() {
      this.$refs['answer-question-modal'].hide();
    },
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      askAnalystService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", "contatos.xlsx");
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      // this.filter = data;
      // console.log('OnFilter: ', this.filter);
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      Promise.all([
        dropdownService.getAllOrigin(new URLSearchParams()),
        dropdownService.getAllSubjects(new URLSearchParams()),
      ]).then((res) => {
          const origins = res[0].map(item => {
            return { value: item.id, text: item.name };
          });
          this.fields[this.fields.findIndex(item => item.field=='origin')].filterOptions.filterDropdownItems = origins;
          const subjects = res[1].map(item => {
            return { value: item.id, text: item.name };
          });
          this.fields[this.fields.findIndex(item => item.field=='subject')].filterOptions.filterDropdownItems = subjects;
          this.setInitialTableFilters();
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      this.tableLoading = true;
      onlyLatestRequest(this, 'loadData', askAnalystService.getAllAskAnalyst(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.tableLoading = false;
          // console.log(res);
          this.items = res.data;
          this.totalRows = res.totalRows;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>